<template>
	<div>
		<!-- <com-back name="Pagsmile"></com-back> -->
		<div class="wrapper" v-if="code == 0">
			<div class="text">
				Mantener un buen historial crediticio le ayudará a aumentar el monto de préstamo
				<img src="@/assets/image/internal/payment/tishi.webp" alt="" class="tishi" />
			</div>
			<div>
				<div class="top_title">Monto de pago</div>
				<div class="bottom_title" :class="{ activeBottomTitle: activeBottomTitle == 1 }" @click="handleBottomTitle(1)">
					<span style="color:#9053F7 ;">$</span>
					<input
						type="text"
						v-model="repayAmount"
						@blur="handleBlur(repayAmount)"
						@input="repayAmount = repayAmount.replace(/\D/g, '')"
					/>
				</div>
			</div>
			<div style="position: relative;">
				<div class="top_title">Comisión</div>
				<div
					class="bottom_title"
					v-if="dataTax.channelPaymentTaxSwith == 'on' && $route.query.reduction == 0"
					:class="{ activeBottomTitle: activeBottomTitle == 2 }"
					@click="handleBottomTitle(2)"
				>
					${{ addComma(dataTax.channelTaxAmount) }}
				</div>
				<div v-else>
					<div
						class="bottom_title"
						:class="{ activeBottomTitle: activeBottomTitle == 2 }"
						@click="handleBottomTitle(2)"
					>
						<span class="jianmian">${{ addComma(dataTax.channelTaxAmount) }}</span>
						<span style="color:#333333;font-weight: normal;">&nbsp;(comisión reducida)</span>
					</div>
					<!-- <img src="@/assets/image/internal/payment/jianmian.png" alt="" class="jianmian_img" /> -->
				</div>
			</div>
			<div class="redio" v-if="isShowRedio == 1">
				<div @click="changeRedio">
					<img src="@/assets/image/internal/select.webp" alt="" v-if="autoReloan == 1" />
					<img src="@/assets/image/internal/select_no.webp" v-else alt="" />
				</div>
				<span>Después de liquidar, obtener el nuevo límite y depositarlo directamente a mi cuenta bancaria</span>
			</div>
			<div class="redio_des">
				Para evitar retrasos en la obtención de tu nuevo crédito debido a los largos tiempos de procesamiento bancario,
				puedes marcar esta opción para obtener los fondos rápidamente. Garantizamos que la tarifa del nuevo préstamo no
				excederá la tarifa de préstamo actual y con un límite mayor.
			</div>
			<div class="bottom">
				<van-button @click="handleButton()"> CONFIRMAR ({{ total ? '$' + total : 0 }}) </van-button>
			</div>
		</div>
		<div class="no_wrapper" v-else>
			El enlace de pago ya está inválido, por favor contacte con nuestro Servicio al Cliente para obtener un nuevo.
		</div>
	</div>
</template>
<script>
	import common from '@/mixins/common.js'
	import { addComma, getQueryVariable } from '@/utils/internal'
	// import comBack from '@/components/internal/back.vue'

	export default {
		mixins: [common],
		data() {
			return {
				selectValue: '',
				repayAmount: '',
				code: '',
				dataTax: {},
				activeBottomTitle: null,
				autoReloan: 0,
				isShowRedio: 0,
				// name: "",
				// backShow: true,
			}
		},
		components: {
			// comBack,
		},
		mounted() {
			this.repayAmount = this.addComma(this.$route.query.repayAmount)
			// this.name = this.$route.query.name;
			document.title = this.$route.query.name
			this.getAccessToken()
			this.getApiHead()
			// window.android.hideTitle();
			this.getRepayTax()
			this.appStatisticsNew()
			this.getAutoReloan()
			window.callbackRiskToken = this.callbackRiskToken
		},
		computed: {
			total() {
				if (this.dataTax.channelPaymentTaxSwith == 'on') {
					return this.addComma(Number(this.repayAmount.replace(/,/g, '')) + Number(this.dataTax.channelTaxAmount))
				} else if (this.dataTax.channelPaymentTaxSwith == 'off') {
					return this.addComma(Number(this.repayAmount.replace(/,/g, '')))
				} else return 0
			},
		},
		methods: {
			addComma,
			getQueryVariable,

			changeRedio() {
				if (this.autoReloan == 1) {
					this.autoReloan = 0
				} else {
					this.autoReloan = 1
				}
			},
			saveAutoReloan() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/autoReloan/update', {
						...this.params,
						autoReloan: this.autoReloan,
					})
					.then(() => {})
			},
			getAutoReloan() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/autoReloan', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.autoReloan = res.data.data?.result
						}
					})
			},
			appStatisticsNew() {
				console.log('this.apiHeadGatewayVh---', this.apiHeadGatewayVh)
				this.$axios
					.post(this.apiHeadGatewayVh + 'auth/appsflyer/appStatisticsNew', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.isShowRedio = res.data.data?.repayPageShowAutoReloan
						}
					})
			},
			//Cursor departure event
			handleBlur(repayAmount) {
				this.repayAmount = this.addComma(repayAmount.replace(/,/g, ''))
			},
			//Add background color
			handleBottomTitle(value) {
				this.activeBottomTitle = value
			},
			//Obtain handling fees
			getRepayTax() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'getRepayTax', {
						...this.params,
						paymentType: 'PSE',
						channelNo: this.getQueryVariable('channelNo'),
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.dataTax = JSON.parse(res.data.data)
							console.log(this.dataTax)
						}
					})
			},
			getRiskTokenByConfig() {
				let string = JSON.stringify({
					code: 3,
					smsFlag: 1,
					calendarFlag: 1,
					appListFlag: 1,
					reqPermission: 0,
					locationFlag: 1,
					trace: (Math.floor(Math.random() * 1000000) + 1).toString(),
				})
				window.android?.getRiskTokenByConfig(string)
			},
			callbackRiskToken(node, token, trace) {
				console.log('callbackRiskToken----nequi----', node, token, trace)
				this.$axios
					.post(
						this.apiHeadGatewayVh + 'repay/record/create',
						{
							...this.params,
							tokenKey: token,
							orderId: this.getQueryVariable('orderId'),
							acctAmount: this.repayAmount.replace(/,/g, ''),
							channelNo: this.getQueryVariable('channelNo'),
							paymentType: this.getQueryVariable('paymentType'),
							channelTaxAmount: this.dataTax.channelPaymentTaxSwith == 'on' ? this.dataTax.channelTaxAmount : 0,
						},
						{
							timeout: 60000,
						},
					)
					.then((res) => {
						this.code = res.data.code
						if (res.data.code == 0) {
							// this.backShow = false;
							// window.android.showTitle();
							window.open(res.data.data.token)
						}
					})
			},
			//Button Jump
			handleButton() {
				if (Number(this.repayAmount.replace(/,/g, '')) < 10000) this.$toast('El pago mínimo: $10000')
				else {
					if (this.isShowRedio) this.saveAutoReloan()
					this.getRiskTokenByConfig()
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/nequi.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
